module.exports = __webpack_public_path__ + "f53a8877b303e6476aff97f65132ec4e.jpg";